import { render, staticRenderFns } from "./EditWSU.vue?vue&type=template&id=486b3e5c&"
import script from "./EditWSU.vue?vue&type=script&lang=js&"
export * from "./EditWSU.vue?vue&type=script&lang=js&"
import style0 from "./EditWSU.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports